// Safe characters that avoid confusion (no O/0, I/1, L, S/5, Z/2, B/8)
const SAFE_CHARS = '23456789ACDEFGHJKMNPQRTUVWXY';
const CODE_LENGTH = 4;

/**
 * Validates if a manual code follows the correct format
 */
export function isValidManualCode(code: string): boolean {
  if (!code || code.length === 0) {
    return true; // Empty is valid (will generate automatically)
  }
  
  if (code.length !== CODE_LENGTH) {
    return false;
  }
  
  const upperCode = code.toUpperCase();
  for (const char of upperCode) {
    if (!SAFE_CHARS.includes(char)) {
      return false;
    }
  }
  
  return true;
}

/**
 * Normalizes a manual code to uppercase
 */
export function normalizeManualCode(code: string): string {
  return code.toUpperCase();
}

/**
 * React Admin validation function for manual code
 */
export const validateManualCode = (value: string | undefined) => {
  if (!value || value.length === 0) {
    return undefined; // Empty is valid
  }
  
  if (!isValidManualCode(value)) {
    return `Manual code must be exactly ${CODE_LENGTH} characters using only: ${SAFE_CHARS}`;
  }
  
  return undefined;
};

/**
 * Formats the input value to uppercase as user types
 */
export const formatManualCode = (value: string | undefined): string => {
  if (!value) return '';
  
  // Remove any characters not in SAFE_CHARS
  const filtered = value
    .toUpperCase()
    .split('')
    .filter(char => SAFE_CHARS.includes(char))
    .join('');
  
  // Limit to CODE_LENGTH characters
  return filtered.slice(0, CODE_LENGTH);
};